import { LandingPageBackdropLayerControls } from './landing-page-backdrop-layer-controls'
import { LandingPageContentLayerControls } from './landing-page-content-layer-controls'
import { LayerManager } from './shared'

export function LandingPageLayerManager() {
	return (
		<LayerManager
			contentLayerControls={<LandingPageContentLayerControls />}
			backdropLayerControls={<LandingPageBackdropLayerControls />}
		/>
	)
}
